import React from "react"
import MetaTags from "react-meta-tags"
import { Container } from "reactstrap"
import WinBackPoolTable from "../../../components/Lead/winbackPool"

const WinBackLeads = () => {
  return (
    <React.Fragment>
      <div className="page-content">
        <MetaTags>
          <title>Win Back Pool | KlikCRM</title>
        </MetaTags>
        <Container fluid>
          <WinBackPoolTable />
        </Container>
      </div>
    </React.Fragment>
  )
}
export default WinBackLeads
